import type { Ref } from 'vue';
import { createError } from '#app'; // Assuming Nuxt context

/**
 * Handles common content fetching errors.
 * Throws the original error if present, otherwise throws a 404 if data is missing.
 * @param error - The error ref from useAsyncData or similar.
 * @param data - The data ref from useAsyncData or similar.
 * @param notFoundMessage - The message for the 404 error. Defaults to 'Pagina niet gevonden'.
 */
export function useCheckContentError(
  error: Ref<Error | null | undefined>,
  data: Ref<any | null | undefined>,
  notFoundMessage: string = 'Pagina niet gevonden'
) {
  if (error.value) {
    throw error.value;
  } else if (!data.value) {
    throw createError({ statusCode: 404, message: notFoundMessage, fatal: true });
  }
}
